import * as dialogTypes from "../constants/DialogActionTypes";

export const openConfirmDialog = (
  title,
  message,
  action,
  cancelText="Cancel",
  confirmText="Confirm",
) =>({
    type: dialogTypes.CONFIRM_DIALOG_OPEN,
    title,message,cancelText,confirmText,action
})

export const cancelConfirmDialog = () =>({
    type: dialogTypes.CONFIRM_DIALOG_CLOSE,
})

export const acceptConfirmDialog = () => ({
  type: dialogTypes.CONFIRM_DIALOG_ACCEPT
})


